import { Box, IconButton } from "@mui/material";
import { useTranslation } from "next-i18next";
import { SortAsc, SortDesc } from "src/components/icons";
import { ISortDirectionType } from "src/types/common";

export enum EnumSortDirection {
    PointingUp = 0,
    PointingDown = 1,
}

export interface ISortDirectionButton {
    sortDirection: ISortDirectionType;
    onClick: () => void;
    isDisabled?: boolean;
    selectedRankingLabel?: string;
}

export const SORT_DIRECTION_BUTTON_TEST_ID = "sort-direction-button";

export const SortDirectionButton = ({ sortDirection, isDisabled = false, onClick, selectedRankingLabel }: ISortDirectionButton) => {
    const { t } = useTranslation("extended-search");

    const ariaLabel =
        sortDirection === EnumSortDirection.PointingUp
            ? t("labels.sort-ascending", { 0: selectedRankingLabel })
            : t("labels.sort-descending", { 0: selectedRankingLabel });

    return (
        <Box sx={{ display: "inline-flex", flexShrink: 0, ...(isDisabled && { cursor: "not-allowed" }) }}>
            <IconButton
                sx={{
                    flexShrink: 0,
                    ...(isDisabled && {
                        color: "gray.200",
                        "& svg": { fill: "currentColor" },
                    }),
                }}
                onClick={onClick}
                disabled={isDisabled}
                variant="outlined"
                size="small"
                aria-label={ariaLabel}
                data-test-id={SORT_DIRECTION_BUTTON_TEST_ID}
            >
                {isDisabled || sortDirection === EnumSortDirection.PointingDown ? <SortDesc boxSize={3} /> : <SortAsc boxSize={3} />}
            </IconButton>
        </Box>
    );
};
